<template>
    <form>
        <div class="form-row">
            <div class="col-4">
                <label for="groupName">Gruppenname</label>
                <input
                    v-model="t_groupName"
                    type="text"
                    class="form-control"
                    id="groupName"
                    placeholder="Gruppenname"
                    title="Eindeutige Bezeichnung der Gruppe"
                    @keydown.enter.prevent
                >
            </div>
        </div>
        <div class="form-row">
            <div class="col-4">
                <label for="cashOrderFile">Kassenanordnungsvorlage</label>
                <div
                    class="form-control-file drop-area"
                    @drop.prevent="handleFileDropCashOrder"
                    @dragover.prevent
                    @click="$refs.cashOrderFile.click()"
                >
                    <input
                        type="file"
                        id="cashOrderFile"
                        ref="cashOrderFile"
                        v-on:change="t_cashOrderFile = $refs.cashOrderFile.files[0]"
                        style="display: none;"
                    />
                    <p v-if="t_cashOrderFile === null">Ziehe die ODT-Vorlage hier rein</p>
                    <p v-else>{{ t_cashOrderFile.name }}</p>
                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="col-4">
                <label for="countingProtocolFile">Zählprotokollvorlage</label>
                <div
                    class="form-control-file drop-area"
                    @drop.prevent="handleFileDropCountingProtocol"
                    @dragover.prevent
                    @click="$refs.countingProtocolFile.click()"
                >
                    <input
                        class="form-control-file"
                        type="file" id="countingProtocolFile" ref="countingProtocolFile"
                        v-on:change="t_countingProtocolFile = $refs.countingProtocolFile.files[0]"
                        style="display: none;"
                    />
                    <p v-if="t_countingProtocolFile === null">Ziehe die ODS-Vorlage hier rein</p>
                    <p v-else>{{ t_countingProtocolFile.name }}</p>
                </div>
            </div>
        </div>
        <div class="form-row d-flex justify-content-end">
            <div class="p-0">
                <a v-on:click="perform('SAVE')" v-on:submit.prevent="onSubmit" class="btn btn-success" href="#"
                   role="button">
                    Gruppe speichern
                </a>
            </div>
        </div>

    </form>
</template>

<script>
import axios from 'axios';

export default {
    name: 'AddGroup',
    components: {},
    data() {
        return {
            error_msg: 'No Error',
            t_groupName: '',
            t_cashOrderFile: null,
            t_countingProtocolFile: null,
        }
    },
    methods: {
        handleFileDropCashOrder(event) {
            this.t_cashOrderFile = event.dataTransfer.files[0];
            console.log(this.t_cashOrderFile);
            this.$refs.cashOrderFile.files = event.dataTransfer.files;
        },
        handleFileDropCountingProtocol(event) {
            this.t_countingProtocolFile = event.dataTransfer.files[0];
            this.$refs.countingProtocolFile.files = event.dataTransfer.files;
        },
        perform(actionType) {
            if (!confirm('Gruppe speichern?')) {
                return;
            }
            let msg = {type: "NONE"}
            const data = new FormData();
            data.append('groupName', this.t_groupName)
            if (this.t_cashOrderFile !== null) {
                data.append('cashOrderFile', this.t_cashOrderFile)
            }
            if (this.t_countingProtocolFile !== null) {
                data.append('countingProtocolFile', this.t_countingProtocolFile)
            }
            let credentials = JSON.parse(localStorage.getItem('credentials'))
            axios({
                url: process.env.VUE_APP_ROOT_API
                    + '/groups',
                data: data,
                auth: credentials,
                method: 'post'
            }).catch(e => {
                console.log(e);
            }).then(resp => {
                msg = resp.data
                console.log("Message")
                console.log(msg)
                if (!(msg.type === "NONE")) {
                    console.log("Pushing error")
                    this.$store.commit('add_message', msg)
                } else if (!(msg.type === "ERROR")) {
                    this.t_groupName = ''
                }
                this.$store.dispatch('loadGroupData')
            });
            this.t_groupName = ''
            this.t_cashOrderFile = null
            this.t_countingProtocolFile = null
            this.$refs.cashOrderFile.value = null
            this.$refs.countingProtocolFile.value = null

        },
    },
    computed: {
        accountName() {
            return this.$store.state.current_acc;
        }
    }
};
</script>

<style scoped>
    .drop-area {
        border: 2px dashed #ccc;
        border-radius: 4px;
        padding: 20px;
        text-align: center;
        cursor: pointer;
        transition: border-color 0.3s ease;
    }

    .drop-area:hover {
        border-color: #888;
    }

    .drop-area p {
        margin: 0;
        font-size: 14px;
        color: #666;
    }
</style>

